import api from "@axios";
import store from "@/store/index.js";
import Vue from "vue";

class Auth {
  // Register
  static async register(data) {
    await api.post("/auth/register", data);
  }
  // Login
  static async login(data) {
    const { data: resData } = await api.post("/auth/login", data);
    this.storeToken(resData.token);
  }
  // Login with provider
  static async loginWith(provider) {
    try {
      const { data } = await api.get(`/auth/${provider}/redirect`);
      location.href = data.link;
    } catch (e) {
      Vue.prototype.$swal({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    }
  }
  static async loginWithCallback(link) {
    const { data } = await api.get(link);
    this.storeToken(data.token);
  }

  // -----------------------------
  // Magic link (passwordless login)
  // -----------------------------
  /**
   * Request a "magic link" email.
   *
   * Frontend sends: { email, recaptcha }
   * Suggested backend behavior:
   * - Always respond with 200 (even if email doesn't exist) to prevent account enumeration.
   */
  static async requestMagicLink({ email, recaptcha }) {
    await api.post("/auth/magic-link", { email, recaptcha });
  }

  /**
   * Consume/verify the token from the email link and obtain an auth token.
   *
   * Expected backend response: { token: "..." }
   */
  static async consumeMagicLink(token) {
    const { data } = await api.get("/auth/magic-link", {
      params: { token },
    });

    if (data?.token) this.storeToken(data.token);
    return data;
  }

  // Fetch user details
  static async fetch() {
    const user = store.state.user.user;
    if (user) return user;
    if (!localStorage.getItem("token")) return null;
    try {
      const { data } = await api.get("/auth/user");
      store.commit("SET_USER_DATA", data);
    } catch {
      localStorage.removeItem("token");
      store.commit("LOGOUT");
      console.log("failed to fetch the user");
    }
    return store.state.user.user;
  }
  // Verify email
  static async verifyEmail(token) {
    await api.post("/auth/verify", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  // Password
  static async sendResetPass(email) {
    return await api.post("/auth/reset-pass", { email });
  }
  static async updatePass(token, password) {
    await api.post(
      "/auth/update-pass",
      { password },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
  // Store Token
  static storeToken(token) {
    localStorage.setItem("token", token);
    window.location.reload();
  }
  // Logout
  static async logout() {
    await api.post("/auth/logout");
    localStorage.removeItem("token");
    window.location.reload();
  }

  // Update billing details for the current user
  static async updateBilling(payload) {
    // Use Billing service (which transparently mocks when VUE_APP_MOCK_BILLING=true)
    const Billing = (await import("@/services/billing.service.js")).default;
    const data = await Billing.updateBilling(payload);
    store.commit("SET_BILLING_DATA", data);
    return data;
  }
}

export default Auth;
